import { Project } from '../types'

import fullSized01 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_01_full.gif'
import thumbnail01 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_01_thumb.png'
import thumbnailHover01 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_01_thumb_hover.png'
import fullSized02 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_02_full.png'
import thumbnail02 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_02_thumb.png'
import thumbnailHover02 from '../assets/projects/IlluEuropraid2018/illuEuropraid2018_02_thumb_hover.png'

const project: Project = {
  anchor: 'europraid2018',
  backgroundColor: '#C5D5D0',
  darkMenuText: false,
  description: `Eté 2018. Voyage solidaire réalisé via EUROPRAID avec mon association, Lady in Raid, & nos amis pirates Rackham the Raid.

Un parcours à travers l'Europe plus que riche en émotions
Un sentiment de communauté soudée très fort.
Le ravissement d'avoir fait la BA de notre vie, ensemble.`,
  descriptionPosition: 'LEFT',
  images: [
    {
      fullSized: fullSized01,
      thumbnail: thumbnail01,
      thumbnailHover: thumbnailHover01,
    },
    {
      fullSized: fullSized02,
      thumbnail: thumbnail02,
      thumbnailHover: thumbnailHover02,
    },
  ],
  menuGradientColor: '#859991',
  music: {
    label: 'Cat Stevens - Wild World',
    link: 'https://youtu.be/6iC6K8fZDik',
    linkColor: '#FCF88E',
  },
  tags: ['Illustration', 'Voyage', 'Solidarité'],
  title: 'Seuls au monde',
}

export default project
